import React from 'react';
import OKAPI from '@api';
import config from '@root/config';
import to from 'await-to-js';

import moment from 'moment';
import _get from 'lodash/get';
import _map from 'lodash/map';
import Cookies from 'js-cookie';
import Toast from '@libs/toast';
import _concat from 'lodash/concat';
import _filter from 'lodash/filter';
import _forEach from 'lodash/forEach';
import _assignIn from 'lodash/assignIn';
import { formatRequest } from '@libs/discovery';
import Session from '@libs/session';
import { facetFilterQms } from '../../helpers/constant';

moment.locale('id');

const WidgetContext = React.createContext({});

const defaultSearchQuery = {
    hitsPerPage: 100,
    page: 0,
    analytics: false,
    attributesToRetrieve: "*",
    getRankingInfo: true,
    responseFields: "*",
    facets: [
        "locations.id",
        "countryCode",
        "gender",
        "languages",
        "locations.area",
        "locations.idx",
        "locations.insuranceLocal.name",
        "locations.insuranceLocal.plans",
        "plan",
        "published",
        "searchSpec",
        "speciality",
        "speciality_title",
        "verified"
    ],
    "facetFilters": [],
    nestedFilters: [],
};

class WidgetProvider extends React.Component {
    state = {
        when: Date.now() + config.otpTimeout * 1000,
        verifying: false,
        search: {
            done: false,
            loading: false
        },
        book: {
            loading: false,
            done: false,
            appointment: false
        },
        manage: {
            appointments: [],
            loading: false,
            done: false
        },
        appointment: {
            loading: false,
            done: false,
            detail: false
        },
        verify: {
            loading: false,
            done: false
        },
        otp: {
            loading: false
        },
        queue: {
            loading: false
        },
        payment: {
            loading: false
        },
        paymentMethod: {
            loading: false
        },
        validate: {
            loading: false
        },
        paymentMethods: [],
        listPaymentMethods: [],
        cash: {},
        country: '',
        doctors: [],
        result: false,
        facilityData: false,
        // new
        specialities: [],
        doctor: false,
        ...this.props.initialState
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.initialState.token !== prevProps.initialState.token) {
            this.setState({
                token: this.props.initialState.token
            });
        }
    }

    GetCurrentCountry = async() => {
        const [, country] = await to(OKAPI.discovery.GetIpByCountry());
        const iso = (_get(country, 'data.data.iso') === '-' ? 'AE' : _get(country, 'data.data.iso')) || 'AE'
        this.setState({
            country: iso
        })
    }

    GetAvailability = async(doctorIdx, serviceId, facilityID) => {
        let { doctor } = this.state;
        const availabilities = await to(OKAPI.appointment.GetAvailability(doctorIdx, serviceId, moment().format('YYYY-MM'), facilityID));
        if (availabilities[1]) {
            const nextMonth = moment().add(1, 'months').format('YYYY-MM')
            const nextAvailabilities = await to(OKAPI.appointment.GetAvailability(doctorIdx, serviceId, nextMonth, facilityID));
            let nextSlotData = [];
            if (nextAvailabilities[1]) {
                nextSlotData = _get(nextAvailabilities[1], 'data', []);
            }
            
            const currentSlotData = _get(availabilities[1], 'data', []);

            const slot = _concat(currentSlotData, nextSlotData);
            doctor.availabilities = _map(slot, (s) => ({
                label: moment.parseZone(s.date).format('dddd, MMM D'),
                value: s.date
            }));

            this.setState({
                doctor: {
                    ...doctor
                }
            });
        }
    }

    GetAvailabilityByDate = async(doctorIdx, serviceId, date, facilityId) => {
        let { doctor } = this.state;

        const timeslots = await to(OKAPI.appointment.GetAvailabilityByDate(doctorIdx, serviceId, date, facilityId));
        if (timeslots[1]) {
            const slot = _get(timeslots[1], 'data', false);
            doctor.timeslot = slot.map((t) => {
                if (+t.slotsAvailable > 0) {
                    return {
                        data: t,
                        label: `${moment.parseZone(t.time).format('HH:mm')} WIB - ${moment.parseZone(t.end_time).format('HH:mm')} WIB` ,
                        value: t.time
                    };
                }
            });
            this.setState({
                doctor: {
                    ...doctor
                }
            })
        }
    }

    ValidateValue = (data) => new Promise(async(resolve, reject) => {
        this.setState({ validate: {
            loading: true
        }});
        const queue = {
            facility_id: +data.facility_id,
            practitioner_id: +data.practitioner_id,
            patient_name: data.patient_name,
            phone: `${data.phone}`,
            dob: `${data.dob}`,
            email: `${data.email}`,
            gender: `${data.gender}`,
            phone_verification_token: `${data.phone_verification_token}`
        }

        let payload = _assignIn(queue, data);

        payload.facility_id = +payload.facility_id;
        payload.practitioner_id = +payload.practitioner_id;

        const [err, res] = await to(OKAPI.qms.Validate(payload));
        if (err || res) { 
            this.setState({ validate: {
                loading: false
            }});
        }

        if (err) reject(err);

        return resolve(res);
    });

    RequestOTPFromWidget = async(phone, type, facilityId) => new Promise(async(resolve, reject) => {
        const response = await to(OKAPI.account.RequestOTPFromWidget(phone, type, facilityId));
        this.setState({
            otp: {
                loading: true
            }
        });
        if(response[0]) {
            reject(response[0]);
            this.startCountdown();
            this.setState({
                otp: {
                    loading: false
                }
            });
        } else {
            resolve(response[1]);
            this.startCountdown();
            this.setState({
                otp: {
                    loading: false
                }
            });
        }
    });

    CreateQueue = async(data) => new Promise(async(resolve, reject) => {
        const queue = {
            facility_id: +data.facility_id,
            practitioner_id: +data.practitioner_id,
            patient_name: data.patient_name,
            phone: `${data.phone}`,
            dob: `${data.dob}`,
            email: `${data.email}`,
            gender: `${data.gender}`,
            phone_verification_token: `${data.phone_verification_token}`
        }

        let payload = _assignIn(queue, data);

        payload.facility_id = +payload.facility_id;
        payload.practitioner_id = +payload.practitioner_id;
        this.setState({
            queue,
            verifying: true
        })
        const response = await to(OKAPI.qms.CreateQueue(payload));
        if(response[0]) {
            reject(response[0]);
            this.startCountdown();
            this.setState({
                verifying: false
            });
        } else {
            this.setState({
                result: _get(response[1], 'data.data', false),
                verifying: false
            });
            resolve(response[1]);
            this.startCountdown();
        }
    });

    QueueDetail = async(queueToken) => new Promise(async(resolve, reject) => {
        this.setState({
            queue: {
                ...this.state.queue,
                loading: true
            }
        });
        const response = await to(OKAPI.qms.QueueDetail(queueToken));
        if(response[0]) {
            Toast.show(_get(response[0], 'data.error_message', ''), 'error', 3000);
            this.setState({
                queue: {
                    detail: false,
                    loading: false,
                    done: true
                }
            });
            reject(response[0]);            
        } else {
            const detail = _get(response[1], 'data.data', false);
            this.setState({
                queue: {
                    detail,
                    loading: false,
                    done: true
                }
            });
            if (detail) {
                Session.set('queue_token', detail.queue_token);
                this.GetPaymentMethods(detail.queue_token, detail.facility.id);
            }
            resolve(response[1]);
        }
    });

    Search = async({ insurance, speciality, gender, language, facility, attributesToRetrieve = '*' }) => {
        this.setState({
            search: {
                ...this.state.search,
                loading: true
            }
        });
        if (facility) {
            let query = {
                ...defaultSearchQuery,
                attributesToRetrieve,
                facetFilters: []
            }
            query.facetFilters.push([`locations.id:${facility}`]);
            
            if (speciality) {
                query.facetFilters.push([
                    `searchSpec:${speciality}`
                ])
            }

            if (insurance) {
                query.facetFilters.push([
                    `locations.insuranceLocal.name:${insurance}`
                ])
            }

            if (gender && gender !== "") {
                if (gender !== "any") {
                    query.facetFilters.push([
                        `gender:${gender}`
                    ])
                }
            }
            if (language && language.length > 0) {
                _forEach(language, (l) => {
                    if (l !== "any") {
                        query.facetFilters.push([
                            `languages:${l}`
                        ])
                    }
                });
            }
            query.facetFilters.push(
                ['plan:2'],
                ['locations.fg_queue:true'],
            );
            query = { ...query, nestedFilters: `[${facetFilterQms(facility).nestedFilters}]` };

            const [err, response] = await to(OKAPI.http.qms.post(`/search/indexes/${config.doctor_index}/query`, {
                params: formatRequest(query)
            }));
            if (err) {
                this.setState({
                    search: {
                        loading: false,
                        done: true
                    }
                });
                throw err;
            }
            const doctors = _get(response, 'data.hits', []);
            this.setState({
                doctors,
                search: {
                    loading: false,
                    done: true
                }
            });
        }
    }

    VerifyAndLoginByPhone = (phone, code, facilityId) => new Promise(async(resolve, reject) => {
        this.setState({
            verify: {
                ...this.state.verify,
                loading: true
            }
        });
        
        const data = {
            phone: phone,
            phone_verification_token: code,
            facility_id: +facilityId,
            filter: `${facilityId}`
        }
        
        const response = await to(OKAPI.account.VerifyAndLoginByPhone(data));

        if(response[0]) {
            reject(response[0]);
            this.startCountdown();
            this.setState({
                verify: {
                    ...this.state.verify,
                    loading: false
                }
            });
        } else {
            this.setState({
                verify: {
                    loading: false,
                    done: true
                }
            });
            this.setState({
                result: _get(response[1], 'data.data', false)
            })
            const token = _get(response[1], 'data.data.token', false) || false;
            if (token) {
                Cookies.set('user.token', token, {
                    expires: 1
                });
            } else {
                Cookies.remove('user.token');
            }
            resolve(response[1]);
            this.startCountdown();
        }
    })

    startCountdown = () => {
        this.setState({
            when: Date.now() + config.otpTimeout * 1000
        });
    }

    GetInitialData = async(facilityId) => {
        let specialities = [];
        const [err, response] = await to(OKAPI.qms.GetInitialData(facilityId));
        if (!err) {
            specialities = _get(response, 'data.facets.searchSpec', []);
            specialities = _map(specialities, (s, k) => ({
                value: k,
                label: k,
                count: s
            }));
            specialities.sort((a,b) => {
                if (a.value > b.value) {
                    return 1;
                }
                if (a.value < b.value) {
                    return -1;
                }
                return 0;
            });
        }

        this.setState({
            specialities
        });
    }

    GetPractitioner = async(slugUrl) => {
        this.setState({
            doctorLoading: false,
        });
        const [err, response] = await to(OKAPI.discovery.GetPractitioner(slugUrl));
        if (err) {
            throw new Error(`No Practitioner Found : ${slugUrl}`);
        }
        let doctor = _get(response, 'data', false);
        if (!_get(doctor, 'id', false)) {
            doctor = _get(response, 'data.data', false);
        }

        this.setState({
            doctor,
            doctorLoading: false
        });

        return doctor;
    }

    PayWithCash = async(queueToken) => {
        this.setState({
            payment: {
                loading: true
            }
        });

        const [err, response] = await to(OKAPI.qms.ChoosePaymentMethod({
            queueToken,
            paymentMethod: 'cash'
        }));
        
        this.setState({
            payment: {
                loading: false
            }
        });

        if (err) {
            Toast.show(_get(err, 'data.error_message', ''), 'error', 3000);
            throw err;
        }

        return response;
    }

    GetPaymentToken = async(queueToken, paymentMethod) => {
        this.setState({
            payment: {
                loading: true
            }
        });

        const [err, response] = await to(OKAPI.qms.ChoosePaymentMethod({
            queueToken,
            paymentMethod
        }));
        this.setState({
            payment: {
                loading: false
            }
        });

        if (err) {
            Toast.show(_get(err, 'data.error_message', ''), 'error', 3000);
            throw err;
        }

        return response;
    }

    GetPaymentMethods = async(queueToken, facilityId) => {
        if (!queueToken.includes("uq-")) {
            this.setState({
                paymentMethod: {
                    loading: true
                }
            });
    
            const [err, response] = await to(OKAPI.qms.GetPaymentMethods({
                queueToken,
                facilityId
            }));
    
            this.setState({
                paymentMethod: {
                    loading: false
                }
            });
    
            if (err) {
                Toast.show(_get(err, 'data.error_message', ''), 'error', 3000);
                throw err;
            }
            const paymentMethods = (_get(response, 'data.data') || []);
            const cash = paymentMethods[0];
            this.setState({
                cash,
                listPaymentMethods: _filter(paymentMethods, (e, i) => i > 0).map(e => ({...e, value: e.payment_method_code, label: e.payment_method_name })),
                paymentMethods: paymentMethods.map(e => ({...e, value: e.payment_method_code, label: e.payment_method_name }))
            })
            return response;
        }
    }

    ConfirmAppointment = async(queueToken, dob) => {
        const [err, response] = await to(OKAPI.qms.UpdateAppointmentStatus(queueToken, dob));

        if (err) {
            throw err;
        }

        Toast.show('Kehadiran berhasil dikonfirmasi', 'success', 3000);
        await this.QueueDetail(queueToken);
        return response;
    }

    CancelAppointment = async(queueToken, dob) => {
        const [err, response] = await to(OKAPI.qms.AppointmentCancel(queueToken, dob));

        if (err) {
            throw err;
        }

        Toast.show('Antrian berhasil dibatalkan', 'success', 3000);
        await this.QueueDetail(queueToken);
        return response;
    }

    render() {
        const value = {
            ...this.state,
            actions: {
                Search: this.Search,
                GetAvailabilityByDate: this.GetAvailabilityByDate,
                GetAvailability: this.GetAvailability,
                RequestOTPFromWidget: this.RequestOTPFromWidget,
                VerifyAndLoginByPhone: this.VerifyAndLoginByPhone,
                startCountdown: this.startCountdown,
                GetCurrentCountry: this.GetCurrentCountry,
                CreateQueue: this.CreateQueue,
                QueueDetail: this.QueueDetail,
                GetInitialData: this.GetInitialData,
                GetPractitioner: this.GetPractitioner,
                PayWithCash: this.PayWithCash,
                GetPaymentToken: this.GetPaymentToken,
                ValidateValue: this.ValidateValue,
                ConfirmAppointment: this.ConfirmAppointment,
                CancelAppointment: this.CancelAppointment,
            }
        }
        return (
            <WidgetContext.Provider value={value}>{this.props.children}</WidgetContext.Provider>
        )
    }
}

WidgetProvider.defaultProps = {
    initialState: {
        specialities: [],
        doctors: []
    }
}

export { WidgetProvider, WidgetContext };
